import { useQuery } from '@tanstack/react-query';

import Api from '@/services/api';
import { OWAS_QUERY_KEYS } from '../enums';
import type { BaseContext } from '@/types';
import type { OwasReportFrame } from '@/types/entities/OwasReportFrame';

type GetOwasFramesRequest = BaseContext & {
	limit: number;
	offset: number;
	file_id: string;
	report_id: string;
	task_name?: string;
	not_analyzed?: boolean;
};

export interface OwasFrameResult {
	id: string;
	created_at: Date;
	updated_at: Date;
	deleted_at: null;
	owas_report_frame_id: string;
	owas_category_id: string;
	owas_sub_category_id: string;
	owas_category: OwasCategory;
}

export interface OwasCategory {
	id: string;
	name: string;
	description: string;
	created_at: Date;
	updated_at: Date;
	deleted_at: Date | null;
}

export type OwasFrame = OwasReportFrame & {
	owas_report_frame_results: any;
	results: OwasFrameResult[];
};

type GetOwasFramesResponse = {
	limit: number;
	total: number;
	offset: number;
	rows: OwasFrame[];
};

async function getFrames(params: GetOwasFramesRequest): Promise<GetOwasFramesResponse> {
	const url = `/ergonomic-tool/owas/report/${params.report_id}/frame`;
	const { data } = await Api.get<GetOwasFramesResponse>(url, { params });
	return data;
}

export const useGetOwasFrames = (params: GetOwasFramesRequest) => {
	return useQuery([OWAS_QUERY_KEYS.GET_FRAMES, params], () => getFrames(params));
};
